/* Three Oh Six — nicht mehr kaufbare Zeilen aus dem Warenkorb entfernen.
   Zwei Fälle, beide enden im Checkout mit "Einige Artikel sind nicht mehr verfügbar":
   1) Shopify kappt die Menge einer Zeile auf 0 (Geister-Zeile), das Theme blendet sie nur aus.
   2) Häufiger: die Variante geht auf 0 Bestand, WÄHREND sie im Cart liegt. Dann bleibt die
      Zeile bei quantity 1 stehen — cart.js verrät die Verfügbarkeit nicht, nur das
      Produkt-JSON (/products/<handle>.js -> variants[].available).
   Beides fliegt hier wirklich raus, spätestens im letzten Moment vor dem Checkout-Klick.
   Grundregel im Zweifel: NICHT entfernen. Ein ausverkaufter Artikel im Cart ist harmloser
   als ein fälschlich gelöschter Kaufwunsch. */
(function () {
  if (window.TOSCartGhostPurge) return;
  window.TOSCartGhostPurge = true;

  var pending = null; // laufender Purge; verhindert parallele/rekursive Läufe
  var suppressUntil = 0; // eigener cart:refresh darf keinen neuen Purge auslösen
  var lastBadCount = -1; // -1 = noch nichts gelesen; steuert, ob der Checkout warten muss
  var replaying = false; // der wiederholte Checkout-Klick darf nicht erneut abgefangen werden

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function getCart() {
    return fetch(root() + 'cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  /* Produkt-JSON pro Handle. Fehler/404/kaputtes JSON -> null, damit der Aufrufer die
     betroffenen Zeilen unangetastet lässt. root() mit, sonst stimmen Sprach-/Marktpfade nicht. */
  function getProduct(handle) {
    return fetch(root() + 'products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  /* variant_id -> true/false. Nur GETs, deshalb parallel und pro DISTINCT handle nur einer.
     Varianten, für die nichts geladen werden konnte, fehlen in der Map (undefined = keine
     Aussage). Produkte ohne Bestandsführung und Geschenkkarten melden available: true. */
  function availabilityMap(cart) {
    var handles = [];
    (cart && cart.items ? cart.items : []).forEach(function (item) {
      if (item.handle && handles.indexOf(item.handle) === -1) handles.push(item.handle);
    });
    if (!handles.length) return Promise.resolve({});

    return Promise.all(handles.map(getProduct)).then(function (products) {
      var map = {};
      products.forEach(function (product) {
        if (!product || !product.variants) return; // Request fehlgeschlagen -> keine Aussage
        product.variants.forEach(function (variant) {
          map[variant.id] = variant.available !== false;
        });
      });
      return map;
    });
  }

  /* Zu entfernen: Menge <= 0 ODER Variante nachweislich nicht mehr kaufbar.
     Kein Nachweis (Map-Eintrag fehlt) heißt: Zeile bleibt. */
  function badLinesOf(cart) {
    if (!cart || !cart.items || !cart.items.length) return Promise.resolve([]);

    var zeroOnly = cart.items.filter(function (item) {
      return !(item.quantity > 0);
    });

    return availabilityMap(cart)
      .then(function (map) {
        return cart.items.filter(function (item) {
          if (!(item.quantity > 0)) return true;
          return map[item.variant_id] === false;
        });
      })
      .catch(function () {
        // Verfügbarkeit unklar -> nur der Fall, der ohne Zusatzinfo eindeutig ist.
        return zeroOnly;
      });
  }

  function keysOf(items) {
    return items.map(function (item) {
      return item.key;
    });
  }

  /* Immer über item.key entfernen, nie über den line-Index: das Markup im Drawer ist nach
     einer Cart-Mutation veraltet, ein Index würde die falsche Zeile treffen. */
  function removeByKey(key) {
    return fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: 0 }),
    }).catch(function () {
      return null;
    });
  }

  function bulkZero(keys) {
    var updates = {};
    keys.forEach(function (key) {
      updates[key] = 0;
    });
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates }),
    }).catch(function () {
      return null;
    });
  }

  /* Sequentiell, weil jede Cart-Mutation die Antwort der vorherigen ungültig macht. */
  function removeSequential(keys) {
    return keys.reduce(function (chain, key) {
      return chain.then(function () {
        return removeByKey(key);
      });
    }, Promise.resolve());
  }

  function finish(removed) {
    pending = null;
    if (removed > 0) {
      suppressUntil = Date.now() + 2000;
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
    return removed > 0;
  }

  function purge() {
    if (pending) return pending; // Nachzügler hängen sich an den laufenden Lauf

    pending = getCart()
      .then(function (cart) {
        return badLinesOf(cart).then(function (bad) {
          lastBadCount = cart ? bad.length : lastBadCount;
          if (!bad.length) return finish(0);

          var before = bad.length;
          return removeSequential(keysOf(bad))
            .then(getCart)
            .then(function (after) {
              return badLinesOf(after).then(function (rest) {
                lastBadCount = after ? rest.length : lastBadCount;
                if (!rest.length) return finish(before);

                /* Fallback: change.js kann eine schon auf 0 gekappte Zeile als No-Op behandeln. */
                return bulkZero(keysOf(rest))
                  .then(getCart)
                  .then(function (final) {
                    return badLinesOf(final).then(function (left) {
                      lastBadCount = final ? left.length : lastBadCount;
                      if (left.length) {
                        // Kein Retry-Loop — nur melden, das Theme blendet die Zeilen weiterhin aus.
                        console.warn('[TOS] Zeilen nicht entfernbar:', keysOf(left));
                      }
                      return finish(before - left.length);
                    });
                  });
              });
            });
        });
      })
      .catch(function () {
        // Ein Fehler im Purge darf weder Checkout noch Hinzufügen blockieren.
        pending = null;
        return false;
      });

    return pending;
  }

  // 1) Einmal pro Seitenaufruf
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      purge();
    });
  } else {
    purge();
  }

  // 2) Nach jedem Cart-Update (cart.js feuert cart:updated); kurz verzögert, damit die
  //    laufende Mutation durch ist. Eigene Refreshes werden über suppressUntil ausgesiebt.
  document.addEventListener('cart:updated', function () {
    if (Date.now() < suppressUntil) return;
    window.setTimeout(purge, 150);
  });

  // 3) Letzter kontrollierbarer Moment: der Checkout-Klick. Nur abfangen, wenn der zuletzt
  //    gelesene Cart-Stand wirklich betroffene Zeilen hatte — sonst bleibt der Checkout unverzögert.
  document.addEventListener(
    'click',
    function (e) {
      if (replaying) return;
      var btn = e.target && e.target.closest && e.target.closest('[name="checkout"]');
      if (!btn) return;
      if (lastBadCount <= 0) return;

      e.preventDefault();
      purge()
        .catch(function () {})
        .then(function () {
          replaying = true;
          btn.click();
          window.setTimeout(function () {
            replaying = false;
          }, 1000);
        });
    },
    true
  );
})();
